<template>
    <div>
        <div class="modalBox">
            <div class="modalTop" :style="{borderColor:'#333333'}">
                <!-- <div class="topHeader"><Avatar style="background-color: #459846" size="large" icon="ios-person" /></div> -->
                <span class="tit">{{lang=="zh"?immediateSupervisor.userName:immediateSupervisor.userEName}}</span>
                <!-- <div>
                    <div class="row">
                        <div class="tit">T1</div> 
                        <div class="userList">
                            <div style="display: flex"><Tag v-for="(chil,i1) in immediateSupervisor.t1SuccessorInfoList" :key="i1" v-if="i1<3">{{chil.userName}}</Tag></div>
                            <Poptip placement="right" width="280" v-if="immediateSupervisor.t1SuccessorInfoList.length>3">
                                <Button icon="ios-more" size="small"></Button>
                                <div class="Poptipapi" slot="content">
                                    <Tag v-for="(chil,i1) in immediateSupervisor.t1SuccessorInfoList" :key="i1">{{chil.userName}}</Tag>
                                </div>
                            </Poptip>
                        </div>
                    </div>
                    <div class="row">
                        <div class="tit">T2</div> 
                        <div class="userList">
                            <div style="display: flex"><Tag v-for="(chil,i1) in immediateSupervisor.t2SuccessorInfoList" :key="i1" v-if="i1<3">{{chil.userName}}</Tag></div>
                            <Poptip placement="right" width="280" v-if="immediateSupervisor.t2SuccessorInfoList.length>3">
                                <Button icon="ios-more" size="small"></Button>
                                <div class="Poptipapi" slot="content">
                                    <Tag v-for="(chil,i1) in immediateSupervisor.t2SuccessorInfoList" :key="i1">{{chil.userName}}</Tag>
                                </div>
                            </Poptip>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="modalContent">
                <div class="modalItem" v-for="(item,index) in dataList" :key="index">
                    <Card class="cardItem" :style="{borderColor:item.colorFlag}">
                        <p slot="title"  v-if="item.beNullJob=='0'">
                            {{lang=="zh"?item.userName:item.userEName}}
                            <span 
                                v-if="(item.exit_impact) === 'red'"
                                style="
                                    display: inline-block;
                                    width: 12px;
                                    height: 12px;
                                    border-radius: 50%;
                                    margin-left: 8px;
                                    vertical-align: middle;
                                    background-color: #ff4d4f;
                                    box-shadow: 0 0 5px rgba(255, 77, 79, 0.5);
                                "
                                ></span>
                                <!-- 黄色灯 -->
                                <span 
                                v-if="(item.exit_impact) === 'yellow'"
                                style="
                                    display: inline-block;
                                    width: 12px;
                                    height: 12px;
                                    border-radius: 50%;
                                    margin-left: 8px;
                                    vertical-align: middle;
                                    background-color: #faad14;
                                    box-shadow: 0 0 5px rgba(250, 173, 20, 0.5);
                                "
                                ></span>
                                <!-- 绿色灯 -->
                                <span 
                                v-if="(item.exit_impact) === 'green'"
                                style="
                                    display: inline-block;
                                    width: 12px;
                                    height: 12px;
                                    border-radius: 50%;
                                    margin-left: 8px;
                                    vertical-align: middle;
                                    background-color: #52c41a;
                                    box-shadow: 0 0 5px rgba(82, 196, 26, 0.5);
                                "
                                ></span>
                                <span>{{lang == "zh" ? item.talentCategoryName : item.talentCategoryEName }}</span>
                            </p>
                        <p slot="title"  v-else>{{item.jobName}}</p>
                        <p slot="title" >  {{lang == "zh" ? item.talent_transfer_plan_cname : item.talent_transfer_plan_ename }}</p>
                        <!-- <div slot="extra">{{item.position}} &nbsp;</div> -->
                        <div>{{lang=="zh"?item.positionCTitle:item.positionETitle}} &nbsp;
                            <Icon
                            type="ios-key-outline"
                            size="30"
                            v-if="item.key_position == '1'"
                          />
                        </div>
                        <div class="row">
                            
                            <div class="tit">T1</div> 
                            <div class="userList">
                                <div style="display: flex"><Tag v-for="(chil,i1) in item.t1SuccessorInfoList" :key="i1" v-if="i1<3">{{lang=='zh'?chil.userName:chil.userEName}}</Tag></div>
                                <Poptip placement="right" width="280" v-if="item.t1SuccessorInfoList&&item.t1SuccessorInfoList.length>3">
                                    <Button icon="ios-more" size="small"></Button>
                                    <div class="Poptipapi" slot="content">
                                        <Tag v-for="(chil,i1) in item.t1SuccessorInfoList" :key="i1">{{lang=='zh'?chil.userName:chil.userEName}}</Tag>
                                    </div>
                                </Poptip>
                            </div>
                        </div>
                        <div class="row">
                            <div class="tit">T2</div> 
                            <div class="userList">
                                <div style="display: flex"><Tag v-for="(chil,i1) in item.t2SuccessorInfoList" :key="i1" v-if="i1<3">{{lang=='zh'?chil.userName:chil.userEName}}</Tag></div>
                                <Poptip placement="right" width="400" v-if="item.t2SuccessorInfoList&&item.t2SuccessorInfoList.length>3">
                                    <Button icon="ios-more" size="small"></Button>
                                    <div class="Poptipapi" slot="content">
                                        <Tag v-for="(chil,i1) in item.t2SuccessorInfoList" :key="i1">{{lang=='zh'?chil.userName:chil.userEName}}</Tag>
                                    </div>
                                </Poptip>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
       
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
            modal:false,
            dataList:[],
            id:'',
            immediateSupervisor:{
                userName:'',
                t1SuccessorInfoList:[],
                t2SuccessorInfoList:[]
            },
            spinShow:true,
            serialnumber:''
        }
    },
    computed:{
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    created(){
        this.getData()
    },
    methods:{
        getData(){
            this.spinShow=true
            axios.post("/talentInventoryUser/successionInventory", {talentInventoryId:this.id,serialnumber:this.serialnumber}).then((res) => {
                this.spinShow=false
                if(res){
                    this.dataList=res.employee
                    this.immediateSupervisor=res.immediateSupervisor[0]
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.modalBox {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding-top:10px;
    height: 220px;
    // overflow-y: auto;
    .tit {
        color: #000000;
        font-weight: bold;
        margin-right: 8px;
    }
    .row{
        display: flex;
        align-items: center;
        margin: 0;
    }
    .btn {
        display: flex;
        justify-content: flex-end;
        // width: 100%;
        Button{
            margin-right: 20px;
        }
    }
    .modalTop {
        padding: 5px 30px;
        border-radius: 10px;
        box-shadow: 3px 3px 5px #adadad;
        display: flex;
        // flex-direction: column;
        align-items: flex-start;
        line-height: 22px;
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        margin:0 auto;
        .topHeader {
            margin-top:-30px;
            margin-bottom: 10px;
            box-sizing: border-box;
        }
    }
    .modalContent {
        display: flex;
        justify-content: flex-start;
        // flex-wrap: wrap;
        margin-top: 10px;
        width: 100%;
        overflow: auto;
        .modalItem {
            // border-radius: 10px;
            // border:2px solid #adadad;
            // padding: 10px;
            margin:10px;
            p{
                font-weight: bold;
            }
            
            .cardItem {
                width: 220px;
            }
        }
    }
}
.userList {
    // background: rgb(235, 235, 235);
    padding: 3px 0px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    .Poptipapi {
        display: flex;
        flex-wrap: wrap;
    }
}
/deep/.ivu-card-head {
    padding: 2px 8px !important;
}
/deep/.ivu-card-body {
    padding: 8px 8px !important;
}
/deep/.ivu-tag {
    padding: 0 5px;
}
/deep/.ivu-card-extra {
    top:2px !important;
    right:5px !important
}
.modalBox ::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.modalBox ::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #4ea397;
}
.modalBox ::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
</style>


// WEBPACK FOOTER //
// src/components/index/components/SuccessorComponent.vue